export default __webpack_public_path__ + "static/media/heart.b2e325ae.JPG";